const DownArrowIcon = (props: any) => {
    return (
        <svg width={12} height={15} viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M6 14L6 1M6 14L1 9M6 14L11 9"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default DownArrowIcon;
